import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { getFromStorage, removeFromStorage, saveToStorage } from '../../../../helpers/storageUtils';
import { LeadResponse } from '../../../../Models/leadResponse';
import { LOADER_MOTO, ONEROSO } from '../../../../routes.constans';
import { LeadsService } from '../../../../services/Leads/leads.service';
import { ButtonComponent } from '../../../components/button/button.component';
import { BankService } from '../../../services/onerous/banks.service';

import { catchError, of } from 'rxjs';
import { DataLayerService } from '../../../../services/DataLayer/data-layer.service';
import { UtmHandlerService } from '../../../services/utm-handler.service';
import { Bank } from '../../interfaces/financed/banks.interface';
import { ACCESORIES, CEROKM } from '../../onerous-pages.constants';

@Component({
  selector: 'app-financed-vehicle',
  templateUrl: './financed-vehicle.component.html',
  styleUrl: './financed-vehicle.component.scss',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonComponent],
})
export class FinancedVehicleComponent implements OnInit {
  utmHandlerService = inject(UtmHandlerService);
  disabled = signal(true);
  bankForm: FormGroup;
  filteredBanks: Bank[] = [];
  showError = signal(false);

  router = inject(Router);
  fb = inject(FormBuilder);
  leadService = inject(LeadsService);
  banksService = inject(BankService);
  leadData: any;
  private dataLayerService = inject(DataLayerService);

  Banks: Bank[] = [
    {
      Nit: '9013997553',
      Banco: '4 EN MOVIMIENTO S A S',
    },
    {
      Nit: '9002433596',
      Banco: 'ALMACEN MOTOCAMPO S.A.',
    },
    {
      Nit: '9013552349',
      Banco: 'AVENTURA MOTORS SAS',
    },
    {
      Nit: '8600029644',
      Banco: 'BANCO DE BOGOTA',
    },
    {
      Nit: '8903002794',
      Banco: 'BANCO DE OCCIDENTE',
    },
    {
      Nit: '8600518946',
      Banco: 'BANCO FINANDINA S.A.',
    },
    {
      Nit: '8600067979',
      Banco: 'BANCO UNION S.A.',
    },
    {
      Nit: '8909039388',
      Banco: 'BANCOLOMBIA S.A',
    },
    {
      Nit: '8600030201',
      Banco: 'BBVA COLOMBIA',
    },
    {
      Nit: '8020166546',
      Banco: 'BICIMOTOS Y REPUESTOS S.A.S.',
    },
    {
      Nit: '8909009431',
      Banco: 'COLOMBIANA DE COMERCIO S A',
    },
    {
      Nit: '8301466276',
      Banco: 'COOPERATIVA MULTIACTIVA NACIONAL DE GARANTIAS SOLIDARIAS',
    },
    {
      Nit: '9012432577',
      Banco: 'CREDITODO VS S.A.S.',
    },
    {
      Nit: '9003352593',
      Banco: 'CREDITOS ORBE SAS',
    },
    {
      Nit: '9001887110',
      Banco: 'DISTRIBUIDORA MOTOS DE ORIENTE S.A.',
    },
    {
      Nit: '9009637487',
      Banco: 'DISTRICOL MOTOS S.A.S',
    },
    {
      Nit: '9012344170',
      Banco: 'FAMI CREDITO COLOMBIA S.A.S.',
    },
    {
      Nit: '8903032157',
      Banco: 'FEDERACION NACIONAL DE COMERCIANTES EMPRESARIOS - FENALCO SECCIONAL VALLE DEL CAUCA',
    },
    {
      Nit: '9014797335',
      Banco: 'FIABLE S.A.S',
    },
    {
      Nit: '9013339398',
      Banco: 'FINFACIL SAS',
    },
    {
      Nit: '8000266960',
      Banco:
        'FONBIENES COLOMBIA S.A.SOCIEDAD ADMINISTRADORA DE PLANES DE AUTOFINANCIAMIENTO COMERCIAL',
    },
    {
      Nit: '8909169116',
      Banco: 'INDUSTRIA COLOMBIANA DE MOTOCICLETAS YAMAHA S A',
    },
    {
      Nit: '9006940650',
      Banco: 'MEFIA S.A.S',
    },
    {
      Nit: '9007665533',
      Banco: 'MOVIAVAL SAS',
    },
    {
      Nit: '8110435971',
      Banco: 'NECHI MOTOS S.A.S',
    },
    {
      Nit: '8130075478',
      Banco: 'RENTAR INVERSIONES LTDA',
    },
    {
      Nit: '9007755517',
      Banco: 'RESPALDO FINANCIERO SAS',
    },
    {
      Nit: '9013753912',
      Banco: 'S&A GRUPO ESTRATEGICO S.A.S',
    },
    {
      Nit: '9011041835',
      Banco: 'SOCOLFI S.A.S.',
    },
    {
      Nit: '9006290654',
      Banco: 'SOLUCIONES INTEGRALES OB SAS',
    },
    {
      Nit: '8002355059',
      Banco: 'SUMOTO S.A.',
    },
    {
      Nit: '9013472338',
      Banco: 'SUPRECREDITO S.A.S.',
    },
    {
      Nit: '8914101372',
      Banco: 'SUZUKI MOTOR DE COLOMBIA S A',
    },
    {
      Nit: '9007999695',
      Banco: 'VENFI S.A.S',
    },
    {
      Nit: '9002288706',
      Banco: 'ZUPERMOTO S.A.',
    },
    {
      Nit: 'null',
      Banco: 'OTROS BANCOS',
    },
  ];

  constructor() {
    this.bankForm = this.fb.group({
      bank: ['', [Validators.required]],
    });

    this.banksService.getBeneficiaryList('Motos').subscribe((banks: any) => {
      const { data } = banks;
      if (data && data.beneficiarios) {
        this.Banks = data.beneficiarios;
      }
    });
  }

  ngOnInit(): void {
    //const data = this.storageService.getLeadData();
    const data = getFromStorage<LeadResponse>('LeadResponse', 'session');
    console.log('Data entrante', data);

    this.bankForm.valueChanges.subscribe((value) => {
      const { bank: currBank } = value;

      const query = currBank?.toLowerCase() || '';
      if (query === '') {
        this.filteredBanks = [];
        this.showError.set(true);
        this.bankForm.get('bank')?.setErrors({ required: true });
        this.disabled.set(true);
        return;
      }

      this.showError.set(false);
      this.filteredBanks = this.Banks.filter(
        (bank) =>
          bank['Banco'].toLowerCase().includes(query) || bank['Nit']?.toLowerCase().includes(query),
      );
    });

    //this.leadData = this.storageService.getLeadData();
    this.leadData = getFromStorage<LeadResponse>('LeadResponse', 'session');
  }

  handleBankSelected() {
    this.dataLayerService.pushDataLayerOnerous(
      'Button',
      'moto_ecommerce_step_2.3_Prenda',
      'Prenda',
    );
    //const OnerousValue = this.storageService.getItem('OnerousSelection');
    // getFromStorage can return `null`, so provide a safe fallback to a string
    const OnerousValue = getFromStorage<string>('OnerousSelection', 'session') ?? '';

    console.log('Onerosos Value', OnerousValue);

    if (this.bankForm.valid) {
      // Ensure bank value is a string when passed to handleRoute
      const bValue = String(this.bankForm.get('bank')?.value || '');

      console.log('Banco seleccionado para enviar:', this.leadData, bValue);

      const updateFinancedData = {
        lead_id: this.leadData.lead_id || '',
        accept_tos: this.leadData.accept_tos || true,
        prenda: 'SI',
        prendario: bValue,
        set_utm_campaign: this.utmHandlerService.getUtmParams()['utm_campaign'] || '',
        set_utm_content: this.utmHandlerService.getUtmParams()['utm_content'] || '',
        set_utm_medium: this.utmHandlerService.getUtmParams()['utm_medium'] || '',
        set_utm_source: this.utmHandlerService.getUtmParams()['utm_source'] || '',
      };

      this.leadService
        .UpdateInfoLead(updateFinancedData, this.leadData.lead_id)
        .pipe(
          catchError((error) => {
            console.error('Error no bloqueante actualizando prenda:', error);
            return of({ success: false, data: null });
          })
        )
        .subscribe((response) => {
          if (response?.data) {
            removeFromStorage('LeadResponse', 'session');
            saveToStorage('LeadResponse', response.data, 'session');
          }
          this.handleRoute(OnerousValue, bValue);
        });
      console.log('Datos a enviar al backend:', updateFinancedData);
    }
  }

  selectBank(bankSelected: Bank): void {
    this.bankForm.patchValue({ bank: bankSelected['Banco'] });
    // this.selectedBank = bank;
    this.filteredBanks = [];
    console.log(`Banco seleccionado: ${bankSelected.Banco} (${bankSelected.Nit})`);
    this.showError.set(false);
    this.disabled.set(false);
  }

  handleRoute(onerousValue: string, bankValue: string) {
    saveToStorage('SelectedBank', bankValue, 'session');

    if (onerousValue === 'Prenda') {
      this.router.navigate([LOADER_MOTO], { skipLocationChange: true });
      return;
    }

    if (onerousValue === '0KMPrenda') {
      this.router.navigate([`/${ONEROSO}/${CEROKM}`]);
      return;
    }

    if (onerousValue === 'PrendaAccesorios' || onerousValue === 'full') {
      this.router.navigate([`/${ONEROSO}/${ACCESORIES}`]);
      return;
    }
    this.router.navigate([LOADER_MOTO]);
  }
}
